import { NgModule } from '@angular/core';
import { PcUtilsService } from 'app/shared/services/utils/utils.service';

@NgModule({
  providers: [PcUtilsService],
})
export class PcUtilsModule {
  /**
   * Constructor
   */
  constructor(private _pcUtilsService: PcUtilsService) {}
}
